import {useWindowSize as utilWindowSize} from './Window'
import * as utilInputs from './Inputs'
import {Pagination as utilPagination} from './Pagination'

export const useWindowSize = utilWindowSize;
export const useInput = utilInputs;
export const usePagination = utilPagination;